import React from 'react';
import PropTypes from 'prop-types';

import styles from './alert.module.scss';

export const alertIcons = {
  success: 'fas fa-check-circle',
  warning: 'fas fa-exclamation-circle',
  primary: 'fas fa-exclamation-circle',
  danger: 'fas fa-exclamation-triangle',
};

function Alert(props) {
  const {
    setTextCenter,
    message,
    type,
    secondaryMessage,
  } = props;
  return (
    <div className={`${styles[type]} ${setTextCenter ? styles.centerAlert : ''}`}>
      <div data-test="icon">
        <i className={`${styles.icon} ${alertIcons[type]}`} />
      </div>
      <div data-test="alert-message">
        <h4 className={styles.primaryMessage}>{message}</h4>
        {secondaryMessage && (
          <p data-test="secondary-message" className={styles.secondaryMessage}>
            {secondaryMessage}
          </p>
        )}
      </div>
    </div>
  );
}


export default Alert;

Alert.propTypes = {
  setTextCenter: PropTypes.bool,
  message: PropTypes.string.isRequired,
  secondaryMessage: PropTypes.string,
  type: PropTypes.string.isRequired,
};

Alert.defaultProps = {
  setTextCenter: false,
  secondaryMessage: '',
};
